import { withNamespaces } from "react-i18next";
import { Accordion } from "react-bootstrap";
import ShareholderImage from "src/modules/3rd-party-management/assets/images/shareholders.svg";
import { useQuery } from "@tanstack/react-query";
import KYBService from "src/modules/3rd-party-management/apis/admin/KYBService";
import { toast } from "react-toastify";
import OwnershipGraphReactFlow from 'src/modules/3rd-party-management/components/ownership-graph';
import { ReactFlowProvider } from "react-flow-renderer";

const ShareholderGraph = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const idInSource = detailsQuery.data?.company?.idInSource;

    const {
        data: shareholders,
        isFetching: fetchingHolders
    } = useQuery({
        queryKey: [
            '3rd-party-management-kyb-get-organization-details',
            'shareholders-graph',
            idInSource
        ],
        queryFn: async () => {
            const service = KYBService.getInstance();

            return await service.getShareholdersGraph(idInSource, {});
        },
        cacheTime: 10,
        refetchOnWindowFocus: false,
        enabled: !!idInSource,
        retry: 0,
        onError: () => {
            toast(t('Error'), {
                type: 'error'
            });
        }
    });

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('shareholders-graph')}
            className={activeAccordion === 'shareholders-graph' ? 'active' : ''}
            eventKey={'shareholders-graph'}
        >
            <Accordion.Header>
                <img
                    src={ShareholderImage}
                    alt=""
                />
                <span>
                    {t('Shareholders Graph')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="shareholders-section mb-5">
                    {!fetchingHolders && shareholders && (
                        <ReactFlowProvider>
                            <OwnershipGraphReactFlow 
                                data={shareholders}
                            />
                        </ReactFlowProvider>
                    )}
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default withNamespaces()(ShareholderGraph);
